import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { ResourceManager } from '@barthauer/abc/core/resources';
import { AbcCoreComponent } from './abcCoreComponent';

@Injectable({
  providedIn: 'root',
})
export class AbcCoreComponentService {
  private _rtlEnabled = false;
  private _stylingMode: StylingMode = StylingMode.Underlined;
  private loadedComponents = [];
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private coreConfig: AbcConfigService
  ) {
    const config = this.coreConfig.getConfiguration();

    if (config && config.Style) {
      this.stylingMode = <StylingMode>config.Style.Mode;
    } else {
      this.stylingMode = StylingMode.Underlined;
    }

    this.rtlEnabled = ResourceManager.getLanguage() === 'ar' ? true : false;
  }

  loadComponent(component: any, viewContainer?: any): AbcCoreComponent {
    const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);

    this.loadedComponents.push(componentRef);
    const domElement = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    if (viewContainer) {
      viewContainer.insert(componentRef.hostView);
    } else {
      this.appRef.attachView(componentRef.hostView);
      document.body.appendChild(domElement);
    }

    return new AbcCoreComponent(componentRef, domElement);
  }

  public set stylingMode(mode: StylingMode) {
    if (this.loadedComponents.length > 0) {
      this.loadedComponents?.forEach((component) => {
        if (component?.instance?.stylingMode) {
          component.instance.stylingMode = mode;
        }
      });
    }
    this._stylingMode = mode;
  }

  public get stylingMode(): StylingMode {
    return this._stylingMode;
  }

  public set rtlEnabled(rtl: boolean) {
    if (this.loadedComponents.length > 0) {
      this.loadedComponents.forEach((component) => {
        if (component?.instance?.rtlEnabled) {
          component.instance.rtlEnabled = rtl;
        }
      });
    }
    this._rtlEnabled = rtl;
  }

  public get rtlEnabled(): boolean {
    return this._rtlEnabled;
  }
}
export enum StylingMode {
  Outlined = 'outlined',
  Underlined = 'underlined',
  Filled = 'filled',
}
